import { Window } from '@progress/kendo-react-dialogs';
import { useEffect, useState } from 'react';
import { Typography } from '@progress/kendo-react-common';
import styles from './_create-performance-report-dialog.module.scss';
import { getSortedReportingPeriods, ReportingPeriod } from '../../../../Models/ReportingPeriod';
import { BusinessType } from '../../../../Models/BusinessType';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { getMissingReportingPeriods } from '../../../../Helpers/Utilities';
import { DealerReport } from '../../../../Models/DealerReport';
import { Checkbox } from '@progress/kendo-react-inputs';

export interface CreatePerformanceReportProps {
  onCancel: () => void;
  onSubmit: (reportingPeriod: ReportingPeriod & { captureDataFromChildren?: boolean }) => void;
  dealerReports: DealerReport[];
  businessTypes: BusinessType[];
  hasChildClients?: boolean;
}

export default function CreatePerformanceReportDialog(props: CreatePerformanceReportProps) {
  const { onCancel, onSubmit, hasChildClients = false } = props;
  const [selectedPeriod, setSelectedPeriod] = useState<ReportingPeriod>();
  const [availablePeriods, setAvailablePeriods] = useState<ReportingPeriod[]>([]);
  const [businessType, setBusinessType] = useState<BusinessType | null>(props.businessTypes.length === 1 ? props.businessTypes[0] : null);
  const [captureDataFromChildren, setCaptureDataFromChildren] = useState<boolean>(false);
  
  useEffect(() => {
    if (businessType) {
      const periods = getMissingReportingPeriods(props.dealerReports, businessType.id);
      setAvailablePeriods(periods);
    }
  }, [businessType, props.dealerReports]);
  
  return (
    <Window width={550} initialHeight={300}
      title={`Create Reporting Period Input (Select Period)`}
      onClose={() => { onCancel() }}
      modal={true}
      className={styles.createPerformanceReportDialogContainer}
    >
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, height: '100%', alignContent: 'space-between' }}>
        {props.businessTypes.length > 1 && (
          <div>
            <DropDownList
              data={props.businessTypes}
              textField="name"
              value={businessType}
              onChange={(e) => {
                setBusinessType(e.value);
                setSelectedPeriod(undefined);
              }}
              style={{ width: '100%', marginBottom: '10px' }}
              label="Business Type"
            />
          </div>
        )}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            padding: '10px',
            marginRight: '5px',
            height: '100%',
            alignContent: 'flex-start',
            justifyContent: 'flex-start',
            overflowY: 'auto',
          }}
        >
          {getSortedReportingPeriods(availablePeriods).map((period, index) => {
            return (
              <div key={index}
                className={styles.periodButton}
                style={{
                  color: selectedPeriod?.month === period.month && selectedPeriod?.year === period.year
                    ? 'white'
                    : 'grey',
                  background: selectedPeriod?.month === period.month && selectedPeriod?.year === period.year
                    ? '#ff6358'
                    : 'rgba(0, 0, 0, 0.08)',
                }}
                onClick={() => {
                  // alert(`Create report for ${period.month}/${period.year}`)
                  setSelectedPeriod(period);
                }}
              >
                <Typography.h2 style={{ padding: '0px', width: '100%', margin: '0px' }}>
                  {`${period.month.toString().padStart(2, "0")}/${period.year}`}
                </Typography.h2>
              </div>
            )
          })}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {hasChildClients && (
              <Checkbox
                label="Capture Data From Children"
                value={captureDataFromChildren}
                onChange={(e) => setCaptureDataFromChildren(e.value)}
                style={{ marginRight: '10px' }}
              />
            )}
          </div>
          <div style={{ display: 'flex' }}>
            <button
              style={{ width: '100px', marginRight: '10px' }}
              type="button"
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={() => { onCancel() }}
            >
              Cancel
            </button>
            <button
              type="button"
              style={{ width: '170px' }}
              disabled={!selectedPeriod}
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              onClick={() => { 
                onSubmit({
                  ...selectedPeriod!,
                  captureDataFromChildren: hasChildClients ? captureDataFromChildren : undefined
                })
              }}
            >
              Create Report Input
            </button>
          </div>
        </div>
      </div>
    </Window>
  );
}